function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(({
  typography
}) => ({
  iconRoot: {
    width: typography.pxToRem(141),
    height: typography.pxToRem(156)
  }
}));

const Error = props => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 141 156"
  }, props, {
    classes: {
      root: styles.iconRoot
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#808285",
    d: "M26.807 146.885L82.905 155.572 121.006 145.656 73.907 136.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#414042",
    strokeWidth: "7",
    d: "M68.295 108.039c5.014 13.032 3.902 26.538-3.334 40.517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6A6C70",
    strokeWidth: "7",
    d: "M112.909 127.15c-6.318-9.901-9.477-16.08-9.477-18.534"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#414042",
    strokeWidth: "7",
    d: "M84.913 105.515c4.07 13.505 2.96 27.011-3.334 40.517"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCB992",
    d: "M41.796 0L141 4.378 141 109.728 41.796 114.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6A783",
    d: "M0 0L41.796 4.378 41.796 109.728 0 114.106z",
    transform: "rotate(180 20.898 57.053)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#808285",
    strokeWidth: "5",
    d: "M63.143 98.218c12.966-4.335 24.654-5.18 35.064-2.536"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "66.975",
    cy: "70.427",
    fill: "#808285",
    rx: "4.029",
    ry: "4.796"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "88.377",
    cy: "68.408",
    fill: "#808285",
    rx: "3.777",
    ry: "4.796"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#808285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.504 24.738L13.596 24.738 13.596 26.253 0.504 26.252z",
    transform: "translate(5.036 73.709) rotate(1 7.05 25.495)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.511 2.019H3.022V22.213H1.511z",
    transform: "translate(5.036 73.709) translate(2.014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.266 0L4.532 4.934 0 4.934z",
    transform: "translate(5.036 73.709) translate(2.014)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.511 2.019H3.022V22.213H1.511z",
    transform: "translate(5.036 73.709) translate(8.057)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.266 0L4.532 4.934 0 4.934z",
    transform: "translate(5.036 73.709) translate(8.057)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#979797",
    d: "M69.11 122.573l-13.672 1.915c-.504.059-1.005-.097-1.41-.388-.412-.296-.728-.733-.847-1.248l-6.636-27.549c-.112-.445-.01-.905.234-1.292.257-.41.673-.739 1.192-.899l13.692-4.506c.486-.17.972-.13 1.365.083.388.21.679.59.789 1.075l6.633 30.516c.117.562.023 1.106-.234 1.53-.241.397-.627.685-1.105.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6A6C70",
    strokeWidth: "7",
    d: "M28.143 64C23.817 83.94 31.77 100.94 52 115"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "51.5",
    cy: "98",
    fill: "#D8D8D8",
    stroke: "#979797",
    rx: "1.5",
    ry: "2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "square",
    d: "M48.258 101.75L65 97.25"
  }));
};

export default Error;